import { render, staticRenderFns } from "./issuesDialog.vue?vue&type=template&id=21d0b8cd&scoped=true"
import script from "./issuesDialog.vue?vue&type=script&lang=js"
export * from "./issuesDialog.vue?vue&type=script&lang=js"
import style0 from "./issuesDialog.vue?vue&type=style&index=0&id=21d0b8cd&prod&scoped=true&lang=scss"
import style1 from "./issuesDialog.vue?vue&type=style&index=1&id=21d0b8cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0b8cd",
  null
  
)

export default component.exports